import PropTypes from 'prop-types'

function Button({
  children,
  onClick,
  href,
  variant = 'primary',
  disabled = false,
  openInNewTab = false,
  className = '',
  ...props
}) {
  const baseClasses = 'btn-primary'
  const variantClasses = {
    primary: '',
    disabled: 'opacity-50 cursor-not-allowed',
  }

  const classes = `${baseClasses} ${variantClasses[variant] || ''} ${className}`

  // If href is provided, render as link
  if (href) {
    return (
      <a
        href={href}
        target={openInNewTab ? '_blank' : '_self'}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
        className={classes}
        {...props}
      >
        {children}
      </a>
    )
  }

  // Otherwise render as button
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classes}
      {...props}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  href: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'disabled']),
  disabled: PropTypes.bool,
  openInNewTab: PropTypes.bool,
  className: PropTypes.string,
}

export default Button
